// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1sbgl","left":"InfoRow_left__3laqY"};